var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/images/data-providers-head.png","alt":"Data Providers"}}),_c('a',{staticClass:"text",attrs:{"href":"/"}},[_vm._v("\n        Data Providers\n    ")])])
}]

export { render, staticRenderFns }